export default "__VITE_ASSET__DvBX4hTv__"